import { Injectable } from '@angular/core';

import { HttpService } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ShipperAccountInterfaceTypeReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('ShipperAccountInterfaceTypeReference', httpService);
  }
}
